<template>
  <div>
    
    <div class="tr header" v-if="index === 0">
      <div class="th enrol-id">enrol id</div>
      <div class="th description">description</div>
      <div class="th type">type</div>
      <div class="th settings">settings</div>
      <div class="th actions">&nbsp;</div>
    </div>

    <div class="tr" :class="{even: index % 2 === 0}">
      <div class="td enrol-id pre">
        {{enrolProfile.enrolId}}
      </div>

      <div class="td description">
        {{enrolProfile.description}}
      </div>

      <div class="td type pre">
        {{enrolProfile.type}}
      </div>

      <div class="td settings">
        <div v-if="enrolProfile.actility">

          <div class="header">baseUrl</div>
          <div class="value">{{enrolProfile.actility.baseUrl}}</div>

          <div class="header">username</div>
          <div class="value">{{enrolProfile.actility.username}}</div>

          <div class="header">password</div>
          <div class="value">{{maskPassword(enrolProfile.actility.password)}}</div>

          <div class="header">profileName</div>
          <div class="value">{{enrolProfile.actility.profileName}}</div>

          <div class="header">n2nUrl</div>
          <div class="value">{{enrolProfile.actility.n2nUrl}}</div>

          <div class="header">devProfileClassA</div>
          <div class="value">{{enrolProfile.actility.devProfileClassA}}</div>

          <div class="header">devProfileClassC</div>
          <div class="value">{{enrolProfile.actility.devProfileClassC}}</div>

          <div class="header">networkSubscription</div>
          <div class="value">{{enrolProfile.actility.networkSubscription}}</div>

        </div>
      </div>

      <div class="td actions">
        <button type="button" data-tippy-content="edit" class="btn btn-primary btn-sm" @click="emit('edit', enrolProfile)"><font-awesome-icon icon="wrench"/></button>
        <button type="button" data-tippy-content="delete" class="btn btn-danger btn-sm" @click="emit('delete', enrolProfile)" :disabled="!canDelete"><font-awesome-icon icon="trash-alt"/></button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue';
import tippy from 'tippy.js';
import { EnrolProfile } from '@/types';

interface Props {
  enrolProfile: EnrolProfile;
  usedEnrolIdList: string[];
  index: number;
}

const props = withDefaults(defineProps<Props>(), {
  enrolProfile: () => ({}) as EnrolProfile,
  usedEnrolIdList: () => [],
  index: 0
});

const emit = defineEmits<{
  edit: [enrolProfile: EnrolProfile];
  delete: [enrolProfile: EnrolProfile];
}>();


onMounted(async () => {
  tippy('[data-tippy-content]');
});

const canDelete = computed<boolean>(() => {
  return !props.usedEnrolIdList.some(enrolId => enrolId === props.enrolProfile.enrolId);
});

const maskPassword = (password: string): string => {
  if (!password) return '';
  return '•'.repeat(password.length);
};

</script>

<style scoped lang="scss">
@use "@/variables.scss" as *;

.tr {
  display: flex;
  flex-direction: row;
  text-align: left;
  justify-content: space-between;
  margin-bottom: 10px;
}

.tr.even {
  background-color: $bgColourLight;
}

.tr.header {
  border-bottom: 1px solid $bgColour;
}

.th {
  color: $bgColour;
  font-weight: bold;
}

.th, .td {
  padding: 3px;
}

.td.enrol-id, .th.enrol-id {
  width: 15%;
}

.td.description, .th.description {
  width: 20%;
}

.td.type, .th.type {
  width: 10%;
}

.td.settings, .th.settings {
  width: 42%;
}

.td.actions, .th.actions {
  width: 8%;
}

.td.actions button {
  margin:2px;
}

.disabled {
  color:red;
}

.enabled {
  color: green;
}


.header {
  text-align:left;
  color: $bgColour;
  font-weight: bold;
}

.value {
  text-align: left;
  margin-bottom: 0.5rem;
}

.pre {
  font-family: monospace;
  font-weight: bold;
}

</style>